import { useState } from 'react';
// import { NextSeo } from 'next-seo';
import { ViewWrapper, SinglePageWrapper, BlogContentWrapper } from '@/styles/index';
import Navbar from '@/components/Layout/Navbar';
// import Footer from '@/components/Layout/Footer';
import BaseCTA from '@/components/Layout/CTA';
import { getAllFilesFrontMatter } from '@/lib/mdx';
import HeadMeta from '@/components/HeadMeta';
import HeadingBanner from '@/components/HeadingBanner/Section';
import { useSession } from 'next-auth/client';
import dynamic from 'next/dynamic';
import GuidePost from '@/components/GuidePost';

const Footer = dynamic(() => import('@/components/Layout/Footer'));
// const GuidePost = dynamic(() => import('@/components/GuidePost'));

const Guides = ({ guides }) => {
  const [session] = useSession();
  const [searchValue, setSearchValue] = useState('');
  const filteredGuides = guides
    .sort((a, b) => Number(new Date(b.publishedAt)) - Number(new Date(a.publishedAt)))
    .filter(frontMatter => frontMatter.title.toLowerCase().includes(searchValue.toLowerCase()));

  return (
    <ViewWrapper>
      <HeadMeta title="Guides – Pollme: Free online Poll and Micro-Survey tool" />
      <Navbar session={session} />
      <SinglePageWrapper>
        <HeadingBanner heading="Guides" />
        <BlogContentWrapper>
          <div className="heading-search">
            <div className="heading-text">A list of guides for using Pollme.</div>
            <div className="blog-search-wrapper">
              <input
                aria-label="Search Guides..."
                type="text"
                onChange={e => setSearchValue(e.target.value)}
                placeholder="Search Guides..."
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
          </div>
          <div className="posts-list">
            {!searchValue && (
              <>
                <div className="list-section">
                  <h3 className="gradient-text gradient-primary">Most Popular</h3>
                </div>
                <GuidePost
                  title="Getting Started with Pollme"
                  summary="Let's start by creating and sharing your first poll!"
                  slug="getting-started"
                  isLast
                />
              </>
            )}

            <div className="list-section">
              <h3 className="gradient-text gradient-primary">All Guides</h3>
            </div>
            {!filteredGuides.length && 'No guides found.'}
            {filteredGuides.map((frontMatter, index) => (
              <GuidePost
                key={frontMatter.title}
                isLast={filteredGuides.length === index + 1}
                {...frontMatter}
              />
            ))}
          </div>
        </BlogContentWrapper>
      </SinglePageWrapper>
      <BaseCTA />
      <Footer />
    </ViewWrapper>
  );
};

export default Guides;

export async function getStaticProps({ locale }) {
  const guides = await getAllFilesFrontMatter('guides');
  const localePosts = guides.filter(post => post.locale === locale);

  return { props: { guides: localePosts } };
}
